import { render, staticRenderFns } from "./addNoticeViewList.vue?vue&type=template&id=db5070ba&scoped=true"
import script from "./addNoticeViewList.vue?vue&type=script&lang=js"
export * from "./addNoticeViewList.vue?vue&type=script&lang=js"
import style0 from "./addNoticeViewList.vue?vue&type=style&index=0&id=db5070ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5070ba",
  null
  
)

export default component.exports